// rename this file to env.js and ask for admin to fill in the key
const key = 'AIzaSyBq3ZLbWaIhtTElvxM7YCNAuhPem8KrIME';
export const host = 'https://old-api.fencesee.ca';
export default key;
